<template>
  <PlatDataPanelSelect class="enrolling-interview-group"
                       :custom-id="customId"
                       :data-types="['site']"
                       site-group
                       siteLabel="选择教学点">
    <template #default="scope">
      <div class="scope-cont">
        <EnrollInterviewSetting :site="scope.site" studentType="MBA"></EnrollInterviewSetting>
        <keep-alive>
          <TemplateDataGrid :key="`${scope.site}`"
                            gridId="EnrollInterviewGroupListGrid"
                            studentType="MBA"
                            v-bind="scope"></TemplateDataGrid>
        </keep-alive>
      </div>
    </template>
  </PlatDataPanelSelect>
</template>

<script>
import PlatDataPanelSelect from '../../../wrapper/panel/PlatDataPanelSelect'
import TemplateDataGrid from '../../../../../../templates/TemplateDataGrid'
import routeConfig from '../../../../../../../constants/routeConfig'
import EnrollInterviewSetting from './setting/index'
export default {
  name: 'EnrollingInterviewGroup',
  components: {
    PlatDataPanelSelect,
    TemplateDataGrid,
    EnrollInterviewSetting
  },
  data () {
    return {
      customId: ''
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataTile.param]
  }
}
</script>

<style lang="scss">
.enrolling-interview-group {
  height: 100%;
  .scope-cont {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}
</style>
